module.exports = __webpack_public_path__ + "img/end_success.94ac6c29.gif";